export default {
  default: '/'
} as const
